import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage("");
    setLoading(true);
    
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setMessage("If an account exists with this email, a password reset link has been sent.");
      setEmail("");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: "#fcfbf9" }}>
      <Card className="w-full max-w-md rounded-2xl border-[#e5e5e5]">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-center" style={{ color: "#652D90", fontFamily: "Poppins, sans-serif" }}>
            Forgot Password
          </CardTitle>
          <p className="text-center text-sm" style={{ color: "#555555", fontFamily: "Poppins, sans-serif" }}>Enter your email to reset password</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" style={{ fontFamily: "Poppins, sans-serif" }}>Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-xl"
                data-testid="forgot-email-input"
              />
            </div>
            {error && <p className="text-sm" style={{ color: "#e90d01" }}>{error}</p>}
            {message && <p className="text-sm" style={{ color: "#1fb25a" }}>{message}</p>}
            <Button 
              type="submit" 
              className="w-full rounded-full" 
              disabled={loading}
              style={{ backgroundColor: "#652D90", fontFamily: "Poppins, sans-serif" }}
              data-testid="forgot-submit-button"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/login" className="text-sm underline" style={{ color: "#652D90" }}>
              Back to Login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
